import React from 'react';
import PropTypes from 'prop-types';
import invariant from 'invariant';

export const LEFT = 'left';
export const RIGHT = 'right';
export const CENTER = 'center';

export function Cell({ children, className, side, colSpan, noBottomPadding }) {
    invariant(
        side === LEFT || side === RIGHT || side === CENTER,
        `Property side must be either ${LEFT}, ${RIGHT} or ${CENTER}, ${side} given.`
    );

    const classNames = [
        'sidebar__cell',
        'sidebar__cell--' + side,
        className
    ].filter(val => !!val).join(' ');

    return (
        <td className={classNames} colSpan={colSpan} style={noBottomPadding ? { paddingBottom: '0' } : {}}>
            {children}
        </td>
    );
}

Cell.propTypes = {
    side: PropTypes.string.isRequired,
    className: PropTypes.string,
    colSpan: PropTypes.number,
    noBottomPadding: PropTypes.bool,
};

Cell.defaultProps = {
    className: '',
    colSpan: 1,
    noBottomPadding: false,
};
